import { allFinancialAccountTypes } from 'utils/financialAccountTypes'
import { allContactTypes } from 'utils/contactTypes'
const contactRouteTypes = Object.values(allContactTypes).map(t => t.routeType)
const contactRoutesRegexString = contactRouteTypes.join('|')
const financialAccountRouteTypes = Object.values(allFinancialAccountTypes)
  .map(t => t.ACCOUNT_TYPE_ROUTE)
const financialAccountRoutesRegexString = financialAccountRouteTypes.join('|')

export const ONBOARDING_CONTACTS_PATH = `/onboarding/:financialAccountType(${financialAccountRoutesRegexString})/:financialAccountId/:contactType(${contactRoutesRegexString})`
export const ONBOARDING_ADD_CONTACT_PATH = `/onboarding/:financialAccountType(${financialAccountRoutesRegexString})/:financialAccountId/:contactType(${contactRoutesRegexString})/:beneficiaryType(primary|contingent)?/add`
export const ONBOARDING_EDIT_CONTACT_PATH = `/onboarding/:financialAccountType(${financialAccountRoutesRegexString})/:financialAccountId/:contactType(${contactRoutesRegexString})/:contactId/edit`
export const ONBOARDING_GETTING_STARTED_PATH = '/onboarding/getting_started'
export const ONBOARDING_PERSONAL_INFORMATION_PATH = '/onboarding/account_holder/personal_information'
export const ONBOARDING_IDENTITY_VERIFICATION_PATH = '/onboarding/account_holder/identity_verification'
export const ONBOARDING_EMPLOYMENT_DETAILS_PATH = '/onboarding/account_holder/employment_details'
export const ONBOARDING_YOUR_ACCOUNTS_PATH = '/onboarding/your_accounts'
export const ONBOARDING_ACCOUNT_DETAILS_PATH = `/onboarding/:financialAccountType(${financialAccountRoutesRegexString})/:financialAccountId/details`
export const ONBOARDING_REVIEW_AND_SUBMIT_PATH = '/onboarding/review_and_submit'
export const ONBOARDING_CONFIRMATION_PATH = '/onboarding/confirmation'
export const ONBOARDING_TOKEN_PATH = '/onboarding/:token'
export const SECURE_UPLOAD_PATH = '/secure/upload'
export const SECURE_UPLOAD_TOKEN_PATH = '/secure/upload/:token'
export const INVALID_PATH = '/invalid'
export const ONBOARDING_ABOUT_YOU_PATH = '/onboarding/about_you'
export const ONBOARDING_JOINT_OWNER_PATH = `/onboarding/:financialAccountType(${financialAccountRoutesRegexString})/:financialAccountId/joint_account`
export const ONBOARDING_EMPLOYER_INFORMATION_PATH = `/onboarding/:financialAccountType(${financialAccountRoutesRegexString})/:financialAccountId/employer`
export const ONBOARDING_ADDITIONAL_DETAILS_PATH = `/onboarding/:financialAccountType(${financialAccountRoutesRegexString})/:financialAccountId/additional_details`

export const detailsPath = (pathInfo) => {
  const {
    financialAccountId,
    financialAccountType,
  } = pathInfo
  return ONBOARDING_ACCOUNT_DETAILS_PATH
    .replace(':financialAccountId', financialAccountId)
    .replace(':financialAccountType', financialAccountType)
}

export const jointOwnerPath = (pathInfo) => {
  const {
    financialAccountId,
    financialAccountType
  } = pathInfo
  return ONBOARDING_JOINT_OWNER_PATH
    .replace(':financialAccountId', financialAccountId)
    .replace(':financialAccountType', financialAccountType)
}

export const contactsPath = (pathInfo) => {
  const {
    financialAccountId,
    financialAccountType,
    contactType,
  } = pathInfo
  return ONBOARDING_CONTACTS_PATH
    .replace(':financialAccountId', financialAccountId)
    .replace(':financialAccountType', financialAccountType)
    .replace(':contactType', contactType)
}

export const employerPath = (pathInfo) => {
  const {
    financialAccountId,
    financialAccountType,
  } = pathInfo
  return ONBOARDING_EMPLOYER_INFORMATION_PATH
    .replace(':financialAccountId', financialAccountId)
    .replace(':financialAccountType', financialAccountType)
}

export const additionalDetailsPath = (pathInfo) => {
  const {
    financialAccountId,
    financialAccountType,
  } = pathInfo
  return ONBOARDING_ADDITIONAL_DETAILS_PATH
    .replace(':financialAccountId', financialAccountId)
    .replace(':financialAccountType', financialAccountType)
}



// WEBPACK FOOTER //
// ./src/utils/urlPaths.js